import React from "react";
import { ComponentProps } from "../../types/types";

interface Redirectww1ComponentProps extends ComponentProps {}

const Redirectww1Component = (props: Redirectww1ComponentProps) => {
  React.useEffect(() => {
    const newPath = `https://www1.cnhindustrial.com${location.pathname.replace(
      "cnhicorporate/",
      ""
    )}${location.search}`;
    if (location.hostname !== "localhost") {
      location.href = newPath;
    }
  }, []);
  return <></>;
};

export default Redirectww1Component;
